<template>
  <FetchingBox ref="FetchingBoxRef" />
  <ScrollTopBtn />
  <div class="container-lg p-0">
    <div class="bg-dark text-white">
      <FindBox ref="FindBoxRef" @emitCallsignDate="getFindboxCallDate" />
      <!-- <InfoBox :call="search.call" :date="search.date" -->
        <InfoBox ref="InfoBoxRef" @emitNewSearch="newSearch" />
        <NoDataBoxVue ref="NoDataBoxRef" />
      </div>
    <div class="bg-dark text-white">
      <TopMenuBox ref="TopMenuBoxRef" @emitPacketsBtn="topMenuPacketsBtn" @emitMapBtn="topMenuMapBtn" @emitWXBtn="topMenuWXBtn" @emitAltitudeBtn="altitudeBtn"/>
    </div>
    <div class="bg-dark text-white">
      <MapBox ref="MapBoxRef" />
    </div>
    <div class="bg-dark text-white">
      <RawPackets ref="RawPacketsRef" />
    </div>
    <div class="bg-dark text-white">
      <WXTopBox ref="WXTopBoxRef" />
    </div>
    <div class="bg-dark text-white">
      <AltitudeBox ref="AltitudeBoxRef" />
    </div>
  </div>
</template>

<!-- ######################################################################################################## -->

<script setup>
import { ref, onMounted } from 'vue'
// import { useI18n } from 'vue-i18n'
import FindBox from "./components/FindBox.vue"
import NoDataBoxVue from './components/NoDataBox.vue'
import InfoBox from "./components/InfoBox.vue"
import MapBox from './components/MapBox.vue'
import RawPackets from './components/RawPackets.vue'
import ScrollTopBtn from './components/ScrollTopBtn.vue'
import TopMenuBox from './components/TopMenuBox.vue'
import FetchingBox from './components/FetchingBox.vue'
import WXTopBox from './components/WXTopBox.vue'
import AltitudeBox from './components/AltitudeBox.vue'
import { getRawPackets, getClearData } from './js/fetchdata.js'
import { format } from 'date-fns'

// const { t } = useI18n()

const fetchingData = ref(getClearData())
// console.log(fetchingData.value)

const RawPacketsRef = ref()
const FindBoxRef = ref()
const MapBoxRef = ref()
const FetchingBoxRef = ref()
const NoDataBoxRef = ref()
const InfoBoxRef = ref()
const TopMenuBoxRef = ref()
const WXTopBoxRef = ref()
const AltitudeBoxRef = ref()
const urlCall = ref()
const urlDate = ref()
const urlTab  = ref()

let url = new URL(window.location.href)
// console.log('searchParams',url.searchParams)
url.searchParams.get("call") ? urlCall.value = url.searchParams.get("call").toUpperCase().substring(0, 9) : urlCall.value = undefined
url.searchParams.get("date") ? urlDate.value = url.searchParams.get("date").substring(0, 10) : urlDate.value = undefined
url.searchParams.get("tab") ? urlTab.value = url.searchParams.get("tab").substring(0, 1).toUpperCase() : urlTab.value = undefined
// console.log(urlCall.value,urlDate.value,urlTab.value)

onMounted(async () => {
  MapBoxRef.value.visible = false

  if (urlCall.value) {
    let dateReg = /^\d{4}-\d{2}-\d{2}$/
    if (!urlDate.value || !urlDate.value.match(dateReg)) {
      urlDate.value = format(Date.now(), 'yyyy-MM-dd')
      }
    
      FindBoxRef.value.setCallInput(urlCall.value,false,urlDate.value)
    await getFindboxCallDate(urlCall.value,urlDate.value)
    
    if (urlTab.value == 'M' && fetchingData.value.dataType.isLocation) { 
      topMenuMapBtn() 
    }
    if (urlTab.value == 'P' && fetchingData.value.dataType.isPackets) { 
      topMenuPacketsBtn() 
    }
    if (urlTab.value == 'W' && fetchingData.value.dataType.isWx) { 
      topMenuWXBtn() 
    }
    if (urlTab.value == 'A' && fetchingData.value.dataType.isAltitude) { 
      altitudeBtn() 
    }

  }

})

// onMounted(() => {
//   MapBoxRef.value.visible = false
// })


async function getFindboxCallDate(call,date) {
    InfoBoxRef.value.call = call
    InfoBoxRef.value.date = date
    if (call && date) {
        InfoBoxRef.value.visible = true

        FetchingBoxRef.value.visible = true
        fetchingData.value = await getRawPackets(call,date)
        // console.log(fetchingData.value.dataType)
        
      // fetchingData.value >>> MapBoxRef
      MapBoxRef.value.data.array = []
      if (fetchingData.value.totalDistance) {
        for (let i = 0; i < fetchingData.value.array.length; i++) {
          if (fetchingData.value.array[i].latitude && fetchingData.value.array[i].longitude) {
            MapBoxRef.value.data.array.push(fetchingData.value.array[i])
          }
        }
        MapBoxRef.value.data.totalDistance = fetchingData.value.totalDistance
      } else {
        for (let i = 0; i < fetchingData.value.array.length; i++) {
          if (fetchingData.value.array[i].latitude && fetchingData.value.array[i].longitude) {
            MapBoxRef.value.data.array.push(fetchingData.value.array[i])
            break;
          }
        }
      }
        //=========
        
        // console.log('fetchingData.value >>> MapBoxRef: ',MapBoxRef.value.data.array)

        TopMenuBoxRef.value.dataType = fetchingData.value.dataType
        FetchingBoxRef.value.visible = false

        fetchingData.value.array.length ? NoDataBoxRef.value.visible = false : NoDataBoxRef.value.visible = true
     } else {
        InfoBoxRef.value.visible = false
     }

    // console.log('getFindboxCallDate: '+call+' : '+date)
}

function newSearch(call){
  if (urlCall.value) {
      window.location.href = '/aprs/' 
    } else {
      // console.log(call)
      InfoBoxRef.value.tab = false
      fetchingData.value = getClearData()
      RawPacketsRef.value.visible = false
      AltitudeBoxRef.value.visible = false
      InfoBoxRef.value.visible = false
      NoDataBoxRef.value.visible = false
      MapBoxRef.value.visible = false
      TopMenuBoxRef.value.dataType = fetchingData.value.dataType
      MapBoxRef.value.data = fetchingData.value
      RawPacketsRef.value.fetchResult = fetchingData.value
      AltitudeBoxRef.value.fetchResult = fetchingData.value
      FindBoxRef.value.setCallInput(call,!InfoBoxRef.value.visible) 
      WXTopBoxRef.value.removeFetchingWXDataTimer()
      WXTopBoxRef.value.clearWXData()
    }
}

function topMenuMapBtn() {
  InfoBoxRef.value.tab = 'M'
  AltitudeBoxRef.value.visible = false
  MapBoxRef.value.visible = true
  RawPacketsRef.value.visible = false
  WXTopBoxRef.value.removeFetchingWXDataTimer()
  WXTopBoxRef.value.clearWXData()
  // MapBoxRef.value.initMap()
}

function topMenuPacketsBtn() {
  InfoBoxRef.value.tab = 'P'
  AltitudeBoxRef.value.visible = false
  MapBoxRef.value.visible = false
  RawPacketsRef.value.visible = true
  RawPacketsRef.value.fetchResult = fetchingData.value
  WXTopBoxRef.value.removeFetchingWXDataTimer()
  WXTopBoxRef.value.clearWXData()
  // console.log('topMenuPacketsBtn',fetchingData.value)
}

function altitudeBtn() {
  InfoBoxRef.value.tab = 'A'
  MapBoxRef.value.visible = false
  RawPacketsRef.value.visible = false
  WXTopBoxRef.value.removeFetchingWXDataTimer()
  WXTopBoxRef.value.clearWXData()
  AltitudeBoxRef.value.visible = true
  // AltitudeBoxRef.value.fetchResult = fetchingData.value
  // AltitudeBoxRef.value.fetchResult = [{
  //       x: '2021-11-06 23:39:30',
  //       y: 50
  //   }, {
  //       x: '2021-11-07 01:00:28',
  //       y: 60
  //   }, {
  //       x: '2021-11-07 09:00:28',
  //       y: 20
  //   }, {
  //       x: '2023-01-07 11:25:28.852',
  //       y: 10
  //   }]

    let altData = []
    for (let i = 0; i < fetchingData.value.array.length; i++) {
            if (fetchingData.value.array[i]) {
                if (fetchingData.value.array[i].altitude && fetchingData.value.array[i].receivedTime) {
                  if (fetchingData.value.array[i].altitude > -10) {
                    altData.push({x: fetchingData.value.array[i].receivedTime, y: fetchingData.value.array[i].altitude})
                  }
                }
            }
        }
    AltitudeBoxRef.value.fetchResult = altData

}

function topMenuWXBtn() {
  InfoBoxRef.value.tab = 'W'
  AltitudeBoxRef.value.visible = false
  MapBoxRef.value.visible = false
  RawPacketsRef.value.visible = false
  WXTopBoxRef.value.removeFetchingWXDataTimer()
  WXTopBoxRef.value.fetchingWXDataTimer(InfoBoxRef.value.call,InfoBoxRef.value.date)
}

</script>

<!-- ######################################################################################################## -->

<style>
html body {
  background-color: #111;
}

a:hover {
  color: #fff;
}
/*
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */

</style>

<i18n>

</i18n>
